import React from 'react';
import "./playlist.css";
const Playlist = (props) => {
    return (
        <div className="centre-text">
            Search for latest Movies and add them to your playlist
        </div>
    );
}

export default Playlist;